import React from "react";
import SideBar from "../../components/Sidebar";
import ServicesBox from "../Recharge/ServicesBox";
import BillPaymentForm from "./BillPaymentForm";
import BannerSlider from "./BannerSlider";
import RecentTransactions from "./RecentTransactions";

const BillPayment = () => {
  return (
    <div className="container-fluid mt-3">
      <div className="row">
        {/* Sidebar */}
        <SideBar />

        {/* Main Content */}
        <div className="col-md-9 mb-3">
          <div className="card shadow-sm mb-4">
            <div className="card-body">
              {/* Services Box */}
              <div className="mb-3">
                <ServicesBox />
              </div>

              <BillPaymentForm />
            </div>
          </div>

          <RecentTransactions />
        </div>
      </div>
    </div>
  );
};

export default BillPayment;
